import React from 'react';
import LookupManager from './LookupManager';

const VoltageComponent = () => {
    return (
        <LookupManager
            title="Voltage"
            endpoint="voltage"
            placeholder="Voltage value"
            loadingLabel="Loading voltage values..."
            emptyLabel="No voltage values yet."
        />
    );
};

export default VoltageComponent;
